<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000340') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" :placeholder="getMessage_('SWCC000340')" @change="change">
				<el-option label="ALL" value="ALL"></el-option>
				<el-option :key="index" v-for="(msgType, index) in msgTypes" :label="msgType.commCdName" :value="msgType.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'msgType', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		}
	},
	created() {
		if (this.searchParams.msgType == null) {
			this.searchParams.msgType = 'ALL';
		}
		this.data = this.searchParams.msgType;
	}
};
</script>

<style></style>
